/* eslint camelcase: 0 */
export default class Schedule {
  constructor({ open = true, schedule = [], journey } = {}) {
    this.open = open;
    this.journey = journey;
    this.schedule = schedule;
  }
}
